import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { SocialIcon } from "react-social-icons";

function Footer() {
  return (
    <div className="footer-container">
      <section className="social-media">
        <div className="social-media-wrap">
          <div className="footer-logo">
            <Link to="/" className="social-logo">
              <img src="./images/cutlogo2.ico" alt="" className="logo" />
            </Link>
          </div>
          <div className="footer-links">
            <div className="footer-link-wraper">
              <div className="footer-link-items">
                <h2>References</h2>
                <br />
                <a>
                  <Link to="/railway">Roaming Smart Solutions</Link>
                </a>
                <br />
                <a>
                  <Link to="/swinternship">App SW</Link>
                </a>
                <br />
                <br />
                <a>
                  <Link to="/techfpga">ELSYS Eastern EU</Link>
                </a>
                <br />
                <br />
                <a>
                  <Link to="/rsgroup">Roaming Solutions Group</Link>
                </a>
              </div>
            </div>
            <div className="footer-link-wraper">
              <div className="footer-link-items">
                <h2>Social Media</h2>
                <SocialIcon
                  url="https://www.facebook.com/demos.production"
                  className="footer-link-items"
                />
                <SocialIcon
                  url="https://www.instagram.com/demos_milan/"
                  className="footer-link-items"
                />
                <SocialIcon
                  url="https://www.linkedin.com"
                  className="footer-link-items"
                />
                <SocialIcon
                  url="https://www.youtube.com"
                  className="footer-link-items"
                />
              </div>
            </div>
          </div>
          <small className="website-rights">
            Cuttape © 2026 All rights reserved
          </small>
        </div>
      </section>
    </div>
  );
}

export default Footer;
